import { styled } from '@linaria/react';

import { normalize } from '@/utils';

import Demo, { DemoSliderControl } from '@/components/Demo';
import Paper from '@/components/Paper';

import { CODE_BACKGROUND } from './index.constants';

function TextAlign({
  // 'only-flexbox' | 'flexbox-and-text-align'
  variant = 'only-flexbox',
  codeOutput,
}) {
  return (
    <Demo
      initialValues={{
        containerWidth: 100,
        containerHeight: 100,
      }}
      controlPosition="top"
      customGrid={{ gridTemplateColumns: '1fr' }}
      outputWrapper={null}
      controls={[
        <DemoSliderControl
          key="containerWidth"
          id="containerWidth"
          label="Container Width"
          min={30}
          max={100}
          previewRenderer={(val) => `${val}%`}
        />,
      ]}
    >
      {({ containerWidth, containerHeight }) => {
        const containerHeightPx = normalize(
          containerHeight,
          30,
          100,
          70,
          300
        );
        return (
          <>
            <Row>
              <Column>{codeOutput}</Column>
              <DemoColumn>
                <Container
                  style={{
                    width: containerWidth + '%',
                    height: containerHeightPx,
                    textAlign:
                      variant === 'flexbox-and-text-align'
                        ? 'center'
                        : undefined,
                  }}
                >
                  <ParagraphElement includeTruncate={false}>
                    Lorem Ipsum is simply dummy text of the printing
                    and typesetting industry. Lorem Ipsum has been the
                    industry's standard dummy text ever since the
                    1500s.
                  </ParagraphElement>
                </Container>
              </DemoColumn>
            </Row>
          </>
        );
      }}
    </Demo>
  );
}

const Row = styled.div`
  display: flex;
  gap: 24px;
  padding-bottom: 16px;

  @media (max-width: 34rem) {
    flex-direction: column-reverse;
  }
`;
const Column = styled.div`
  position: relative;
  flex: 1;
  background: ${CODE_BACKGROUND};
  border-radius: 8px;
  min-width: 0;
`;

const DemoColumn = styled(Column)`
  display: flex;
  justify-content: center;
`;

const Container = styled(Paper)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0px;
`;

const ParagraphElement = styled.p`
  width: 75%;
  max-height: 100%;
  overflow: hidden;
  overflow: clip;
  border: 4px solid hsl(210deg 20% 40%);
  border-radius: 2px;
  color: hsl(220deg 20% 40%);
  padding: 8px;
  line-height: 1.45;
  hyphens: auto;
`;

export default TextAlign;
